var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66275 13.2136L9.82377 19.7066C11.0068 20.9533 12.9932 20.9533 14.1762 19.7066L20.3372 13.2136C22.5542 10.8771 22.5543 7.08892 20.3373 4.75245C18.1203 2.41598 14.5258 2.41598 12.3088 4.75245C12.1409 4.92935 11.8591 4.92935 11.6912 4.75245C9.47421 2.41598 5.87975 2.41598 3.66275 4.75245C1.44575 7.08892 1.44575 10.8771 3.66275 13.2136Z",
    fill: "#272D36",
    stroke: "#CAE9FF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlue);
export default __webpack_public_path__ + "static/media/Heart_blue.5dd6ee6acb72b6f72b3f4c6e69e2f2b6.svg";
export { ForwardRef as ReactComponent };